import generateErrorMessage from '../../../helper-functions/generateErrorMessage';
import isNotEmptyString from '../../../helper-functions/isNotEmptyString';

/**
 * The message central-api put in a failed subscription response, or
 * `undefined` when the body carries none (no body at all, a network error, a
 * non-JSON gateway page). Callers fall back to their own translated text in
 * that case, so the user is never left without feedback.
 */
export function getSubscriptionErrorMessage(body: unknown): string | undefined {
  if (!body || typeof body !== 'object') {
    return undefined;
  }

  const response = body as { message?: unknown; errors?: unknown };

  const hasMessage =
    typeof response.message === 'string' && isNotEmptyString(response.message);
  const hasErrors =
    !!response.errors &&
    typeof response.errors === 'object' &&
    Object.keys(response.errors as object).length > 0;

  if (!hasMessage && !hasErrors) {
    return undefined;
  }

  const message = generateErrorMessage(response);
  return isNotEmptyString(message) ? message : undefined;
}

/**
 * The text of the error toast for a checkout that could not start: the
 * server's reason when it gave one, otherwise the caller's translated
 * fallback.
 */
export function getCheckoutFailureMessage(
  serverMessage: string | undefined,
  fallback: string
): string {
  return serverMessage && isNotEmptyString(serverMessage)
    ? serverMessage
    : fallback;
}
